import type { FC } from 'react';
import DollarSign from '@wix/da-ds/pkg/Icons/24x24/DollarSign';
import DollarOffers from '@wix/da-ds/pkg/Icons/24x24/DollarOffers';
import ResaleIcon from '@wix/da-ds/pkg/Icons/24x24/Resale';
import { IconSize } from '@wix/da-ds/pkg/Icons/IconWrap';

import s from './ExclusiveTypeIcon.scss';

export enum ExclusiveType {
  FixedPrice = 'fixed_price',
  Offers = 'offers',
  Resales = 'resales',
}

interface Props {
  exclusiveType: ExclusiveType;
  size?: number;
}

const ExclusiveTypeIcon: FC<Props> = ({ exclusiveType, size = 64 }) => {
  return (
    <div className={s['icon']}>
      <div className={s[`icon-${exclusiveType}`]} style={{ width: size, height: size }}>
        {exclusiveType === ExclusiveType.FixedPrice && (
          <DollarSign size={IconSize.MEDIUM} disableDefaultColors />
        )}
        {exclusiveType === ExclusiveType.Offers && (
          <DollarOffers size={IconSize.MEDIUM} disableDefaultColors />
        )}
        {exclusiveType === ExclusiveType.Resales && (
          <ResaleIcon size={IconSize.MEDIUM} disableDefaultColors />
        )}
      </div>
    </div>
  );
};

export default ExclusiveTypeIcon;
